import { TextEditorValue } from '@dreryk/react-text-editor';

import { escapeHtml } from '../textEditorField/textEditorField.utils';

const MAX_FORMATTED_LENGTH = 50000;

export const plainTextToEditorValue = (text: string): TextEditorValue | null => {
   const lines = text
      .split('\n')
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

   if (lines.length === 0) {
      return null;
   }

   const html = lines.map((line) => `<p>${escapeHtml(line)}</p>`).join('');

   return TextEditorValue.fromFormatted(html.slice(0, MAX_FORMATTED_LENGTH));
};
